<script lang="ts">
  import { Container } from "sveltestrap";
  import BookmarkProduct from "./BookmarkProduct.svelte";
  import {leftSideFilter,grid} from "../../../../store"
  import IconsFilters from "./IconsFilters.svelte";
  import ProductDetails from "./ProductDetails.svelte";
  import Filters from "./Filters.svelte";
  let setLeftSideFilter:boolean
  leftSideFilter.subscribe((value) => {
    setLeftSideFilter = value;
  });
  let setGrid:boolean
  grid.subscribe((value) => {
    setGrid = value;
  });
</script>
<BookmarkProduct />
<Container fluid class="product-wrapper {setLeftSideFilter ? 'sidebaron' : ''}">
  <div class="product-grid">
    <div class="feature-products">
      <IconsFilters />
      <Filters />
    </div>
    <div class="product-wrapper-grid {setGrid  ? 'list-view' : ''}">
      <ProductDetails />
    </div>
</div>
</Container>